module.exports = {"name":"@dialogexe/cw-component-paragraph","version":"1.0.3","description":"DX CustomWeb Paragraph Component","main":"Paragraph.tsx","scripts":{},"repository":{"type":"git","url":"git+https://github.com/dialogexe/cw-component-paragraph.git"},"keywords":["paragraph"],"author":"DX","license":"ISC","bugs":{"url":"https://github.com/dialogexe/cw-component-paragraph/issues"},"homepage":"https://github.com/dialogexe/cw-component-paragraph#readme","peerDependencies":{"react":"^16.3.2"},"publishConfig":{"registry":"https://npm.pkg.github.com/"}}


//////////////////
// WEBPACK FOOTER
// ./~/@dialogexe/cw-component-paragraph/package.json
// module id = 1100
// module chunks = 178422501501999